import { ErrorPage } from '../index';
import { initServerTranslation } from '@bts-web/utils-lokalise';

const ErrorAuthTimeoutPage = async () => {
  const { t } = await initServerTranslation();

  return (
    <ErrorPage
      title={t('request_timeout_error_headline')}
      description={t('request_timeout_error_text')}
    />
  );
};

export { ErrorAuthTimeoutPage };
